export const retroThemeVariables = {
    '--global-web-app-loader-border': '#4E95FF',
    '--global-web-app-loader-border-bottom': '#3989FF',
    '--global-web-app-loader-background': '#EEF2F6',
    '--progres-bar': '#5C3D12',
    '--progres-bar-active': '#DD9E02',
    '--quiz-custom-progress-bar': '#5C3D12',
    '--quiz-custom-progress-bar-active': '#DD9E02',
    '--quiz-custom-progress-bar-part-text': '#DD9E02',
    '--background-color': '#FFEEC2',
    '--title-default-color': '#5C3D12',
    '--title-accent-color': '#DD9E02',
    '--sub-title-default-color': '#697586',
    '--radio-button-background-color-quiz': '#FFE5A5',
    '--radio-button-border-color-quiz': '#9E750E',
    '--radio-button-border-hover-color-quiz': '#FEBE20',
    '--radio-button-border-hover-color-quiz-new-h2': '#FEBE20',
    '--radio-button-border-hover-color-quiz-new-s': '#FEBE20',
    '--kickstarter-main-block-border': '#FF9A40',
    '--kickstarter-main-block-background-gradient-1': '#FFE3AE',
    '--kickstarter-main-block-background-gradient-2': '#FFFCF0',
    '--game-button-main-color': '#FFE5A5',
    '--game-button-main-border': '#9E750E',
    '--game-button-main-shadow': '#FFC73B99)',
    '--game-button-main-shadow-visual-game': '#FFC73B99',
    '--game-button-main-shadow-number-face-game': 'rgba(255, 199, 59, 0.60)',
    '--game-background-main-color': '#372A25',
    '--game-tile-clicked-before': '#FFD262',
    '--game-tile-clicked-before-shadow': '#FFD262',
    '--game-tile-clicked-before-sequence': 'rgba(3, 212, 175, 0.10)',
    '--game-tile': '#0C0600',
    '--game-tile-before-sequence': '#E98F4E',
    '--game-tile-choice-sequence': '#FFC73B',
    '--game-tile-hover': '#9AA4B2',
    '--game-progress-bar-background': '#EEF2F6',
    '--game-progress-bar-progress': '#FFC73B',
    '--game-tile-hint-background': 'rgb(89, 19, 155)',
    '--game-visual-element-background': '#FFE5A5',
    '--social-proof-background': '#FFE5A5',
    '--loader-progress': '#FFC73B',
    '--loader-progress-background': '#9E750E',
    '--loader-background': '#FFEEC2',
    '--loader-review-background': '#FFE5A5',
    '--new-s-loader-progress': '#FFC73B',
    '--new-s-loader-progress-background': '#9E750E',
    '--new-s-loader-progress-text': '#5C3D12',
    '--new-s-loader-title-accent': '#DD9E02',
    '--new-s-loader-secondary-text': '#5C3D12',
    '--new-s-loader-review-background': '#FFE5A5',
    '--new-h2-loader-progress': '#FFC73B',
    '--new-h2-loader-progress-background': '#9E750E',
    '--new-h2-loader-progress-text': '#5C3D12',
    '--new-h2-loader-title-accent': '#DD9E02',
    '--new-h2-loader-secondary-text': '#5C3D12',
    '--new-h2-loader-review-background': '#FFE5A5',
    '--social-proof-memory-level-background-gradient-1': '#FFD97C',
    '--social-proof-memory-level-background-gradient-2': 'rgba(255, 181, 0, 0.10)',
    '--social-proof-left-text': '#5C3D12',
    '--social-proof-green-text': '#00957B',
    '--social-proof-bottom-text': '#434343',
    '--plan-page-top-discount-background': '#FFEEC2',
    '--plan-page-top-discount-bottom-border': 'rgba(180, 87, 49, 0.10)',
    '--plan-page-img-module-border-background': 'rgba(254, 190, 32, 0.1)',
    '--plan-page-img-module-background-gradient-1': 'rgba(255, 229, 165, 0.95)',
    '--plan-page-img-module-background-gradient-2': 'rgba(255, 238, 195, 0.95)',
    '--plan-page-img-module-title-default-color': '#5C3D12',
    '--plan-page-img-module-bage-background': 'rgba(238, 168, 75, 0.20)',
    '--plan-page-img-module-left-bage-background': 'rgba(238, 168, 75, 0.20)',
    '--plan-page-img-module-left-bage-text': '#5C3D12',
    '--plan-page-img-module-right-bage-background': '#EEA84B',
    '--plan-page-img-module-right-bage-text': '#FFF',
    '--plan-page-img-module-bage-text-bottom': '#5C3D12',
    '--plan-page-option-background-gradient-1': '#FFE5A5',
    '--plan-page-option-background-gradient-2': '#FFE5A5',
    '--plan-page-option-background-border': '#9E750E',
    '--plan-page-option-background-active-gradient-1': '#FFE5A5',
    '--plan-page-option-background-active-gradient-2': '#FFD46A',
    '--plan-page-option-background-active-border': '#5C3D12',
    '--plan-page-option-most-popular-background': '#5C3D12',
    '--plan-page-option-most-popular-text': '#FFF',
    '--plan-page-option-title': '#5C3D12',
    '--plan-page-option-save-bage-background': 'rgba(238, 168, 75, 0.70)',
    '--plan-page-option-save-bage-text': '#151320',
    '--plan-page-option-part-text': '#C09A64',
    '--plan-page-option-secured-text': '#697586',
    '--plan-page-option-safe-background': 'rgba(238, 168, 75, 0.20)',
    '--plan-page-option-safe-text': '#FF7B43',
    '--plan-page-option-details-text': '#697586',
    '--plan-page-down-sale-popup-accent-text': '#FF7B43',
    '--plan-page-title': '#F6F5F7',
    '--plan-page-title-accent': '#FF7B43',
    '--plan-page-sub-title': '#697586',
    '--plan-page-header-background': '#FFE5A5',
    '--plan-page-promocode-background': 'rgba(255,229,165, 0.9)',
    '--plan-page-promocode-border': '#FEBE20',
    '--plan-page-element-background': 'rgba(255,229,165, 1)',
    '--plan-page-memorize-elements-background': 'rgba(255,197,122, 0.5)',
    '--plan-page-open-text': '#FF7B43',
    '--plan-page-one-line-border': 'rgba(180, 87, 49, 0.10)',
    '--plan-page-bottom-button-shadow-background': 'rgba(255,229,165, 0.9)',
    '--plan-page-viewing-page-counter-background': '#FFE5A5',
    '--plan-page-viewing-page-counter-text': '#5C3D12',
    '--plan-page-options-container-shadow': 'rgba(255, 183, 96, 0.30)',
    '--plan-page-modal-background': 'rgb(255,229,165)',
    '--plan-page-review-arrow-background': 'rgba(255, 229, 165, 1)',
    '--plan-page-review-arrow-border': 'rgba(254, 190, 32, 1)',
    '--plan-page-options-secure-text': '#697586',
    '--plan-page-options-footer-safe-background': 'rgba(238, 168, 75, 0.20)',
    '--plan-page-options-footer-safe-text': '#FF7B43',
    '--offer-page-price-text': '#697586',
    '--offer-page-cross-price-text': '#697586',
    '--offer-page-pagination-bullet': 'rgba(92, 61, 18, 0.4)',
    '--offer-page-pagination-bullet-active': '#5C3D12',
    '--signup-bottom-block-border': '#4E95FF',
    '--signup-bottom-block-background': '#FCFCFD',
    '--thankyou-header-background': '#FFEEC2',
    '--thankyou-page-one-line-border': 'rgba(180, 87, 49, 0.10)',
    '--thankyou-page-sub-border-color': '#FEBE20',
    '--thankyou-page-sub-background-color-one': '#FFEBBB',
    '--thankyou-page-sub-background-color-two': '#FFEBBB',
    '--thankyou-page-sub-welcome-text': '#5C3D12',
    '--thankyou-page-sub-text': '#FF7B43',
    '--thankyou-page-sub-renew-test': '#5C3D12',
    '--thankyou-page-sub-loci-text': '#D78E00',
    '--thankyou-page-steps-header-text': '#5C3D12',
    '--thankyou-page-step-border': '#FEBE20',
    '--thankyou-page-step-background-gradient-1': '#FFEEC3',
    '--thankyou-page-step-background-gradient-2': '#FFE5A5',
    '--thankyou-page-step-number-color-one': '#AA6D19',
    '--thankyou-page-step-number-color-two': '#5C3D12',
    '--thankyou-page-step-header': '#5C3D12',
    '--thankyou-page-step-sub-title': '#D78E00',
    '--thankyou-page-step-google-text': '#151320',
    '--thankyou-page-step-google-border': '#C4C8D9',
    '--thankyou-page-step-google-background': '#FFF',
    '--thankyou-page-step-apple-text': '#FFFFFF',
    '--thankyou-page-step-apple-background': '#000',
    '--thankyou-page-step-download-button-border': '#000',
    '--thankyou-page-step-download-button-background': '#000',
    '--thankyou-page-step-download-button-text-header': '#E8EDFF',
    '--thankyou-page-step-download-button-text-footer': '#E8EDFF',
    '--thankyou-page-step-block-background': '#FFE5A5',
    '--thankyou-page-gamepad-background-gradient-1': '#FFEEC3',
    '--thankyou-page-gamepad-background-gradient-2': '#FFE5A5',
    '--regular-quiz-loader-popup-wrapper-background': 'rgba(13, 18, 28, 0.70)',
    '--regular-quiz-loader-popup-border': '#CDD5DF',
    '--regular-quiz-loader-popup-background': '#FCFCFD',
    '--regular-quiz-loader-popup-title': '#4B5565',
    '--regular-quiz-loader-popup-question': '#202939',
    '--regular-quiz-loader-popup-button-text': '#202939',
    '--regular-quiz-loader-hr-line': '#5C3D12',
} as const;
